import React, { Component } from 'react';
import Top_Bar from '../Part_Sample/Top_Bar';
import { isEmpty } from '../Common/Common';

import CO from '../../Images/iaq_icons/CO.png';
import CO2 from '../../Images/iaq_icons/CO2.png';
import Humidity from '../../Images/iaq_icons/Humid.png';
import Pm25 from '../../Images/iaq_icons/PM25.png';
import Temp from '../../Images/iaq_icons/Temp.png';
import TVOC from '../../Images/iaq_icons/TVOC.png';

export default class IAQ_Monitoring extends Component {
	constructor(props) {
		super(props);

		//LOGIC CHECK IF DEVICE EXIST IN DEVICE LIST.
		//IF ROOM HAS NO DEVICE, DONT SHOW.
		let iaqMonitoringSettings = null;

		//loop thru iaqMonitoringSettings, delete all devices that does not exist
		if(!isEmpty(this.props.param.iaq_monitoring_settings)) {
			iaqMonitoringSettings = JSON.parse(JSON.stringify(this.props.param.iaq_monitoring_settings));

			for (var key in iaqMonitoringSettings) {
				if (iaqMonitoringSettings.hasOwnProperty(key)) {
					if(iaqMonitoringSettings[key].length > 0) {
						let index = iaqMonitoringSettings[key].length;

						while(index--) {
							if(!window.app.state.point_list.hasOwnProperty(iaqMonitoringSettings[key][index].id)){
								iaqMonitoringSettings[key].splice(index, 1);
							}
						}
					}
				}

				//if room does not have any points, delete room
				if(iaqMonitoringSettings[key].length <= 0) {
					delete iaqMonitoringSettings[key];
				}
			}
		}

		// Retain scroll position of groups screen
		this.state = {
			iaqMonitoringSettings: iaqMonitoringSettings,
			scroll_top: 0,
			height: 0
		}
		// Add groups ref for retaining scroll position
		this.groups_ref = React.createRef();
	}

	componentDidMount = () => {
		//resume scroll position
		if (this.props.param.iaq_scroll_top != null) {
			this.groups_ref.current.scrollTop = this.props.param.iaq_scroll_top;
		}

		if (!isEmpty(this.state.iaqMonitoringSettings)) {
			//get element height to calculate square
			const height = this.divElement.clientHeight;
			this.setState({ height });
		}
	}

	//handleAddGroup = () =>{

	//}

	selectedIAQRoom = (room_name) => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.app.content_area.current.content_handler('IAQ_Mon_Details', { iaq_scroll_top: this.state.scroll_top, iaq_monitoring_settings: this.state.iaqMonitoringSettings, room_name: room_name });
	}

	handleOnScroll = () => {
		this.setState({
			scroll_top: this.groups_ref.current.scrollTop,
		})
	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		//Adjust IAQ Monitor cells to fit in screen. Minimum cell_width is 320. 40px extra for margin/padding
		let numOfCellsInARow = Math.trunc(this.props.width / 340);

		let cell_width = Math.trunc((this.props.width / numOfCellsInARow) - 40);

		//if(numOfCellsInARow > 1) cell_width = ((numOfCellsInARow - 1) * 5) + cell_width;

		if(cell_width < 320) {
			if(numOfCellsInARow > 1) {
				cell_width = Math.trunc((this.props.width / (numOfCellsInARow - 1)) - 40);
			} else{
				cell_width = 320;
			}
		}

		let cell_style = {
			cursor: 'pointer',
			minWidth: 320,
			width: cell_width,
			minHeight: 60,
			maxHeight: 200,
			margin: 5,
			padding: 10,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			borderRadius: 20,
			overflow: 'auto'
		}
		//{ display: 'inline-block', width: '90%', marginBottom: '10px', border: '1px solid black' }

		const rgbaCode = {
			'#FF6D6A': { 'r': 255, 'g': 109, 'b': 106 },
			'#FDE26C': { 'r': 253, 'g': 226, 'b': 108 },
			'#8BD5A7': { 'r': 139, 'g': 213, 'b': 167 },
		};

		const opacityValue = 1;

		const iconList = {
			'ac': Temp,
			'co': CO,
			'co2': CO2,
			'humi': Humidity,
			'pm25': Pm25,
			'temp': Temp,
			'tvoc': TVOC,
		};

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('iaq_mon')}
					//right_button_type={this.props.receiver.active_controller.user_class =='Admin'? 'add' : null}
					//handleRightButton={this.props.receiver.active_controller.user_class =='Admin'? this.handleAddGroup : null}
					/>
					<div style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: this.props.width - 10 }}>
						<div ref={this.groups_ref} className='noScrollBar' onScroll={this.handleOnScroll} style={{ height: this.props.height - 130, overflow: 'auto' }}>
							{this.state.iaqMonitoringSettings && Object.keys(this.state.iaqMonitoringSettings).map((room_name, i) => {
								let room_color = '#8BD5A7';
								//#cc3300, #ff9966, #ffcc00, #99cc33, #339900
								//red, 	   beige.	yellow,	 light green, green
								//rgba(204, 51, 0, 1), rgba(255, 204, 0, 1), rgba(51, 153, 0, 1)
								//#FF6D6A			#FDE26C				   #8BD5A7
								this.state.iaqMonitoringSettings[room_name].map((device, i) => {
									let avTemp = window.app.state.point_list[device.id].av;

									if(isEmpty(avTemp)) {
										if(window.app.state.point_list[device.id].type == 'Ac') {
											if(window.app.state.point_list[device.id].hasOwnProperty('temp')) {
												avTemp = window.app.state.point_list[device.id].temp;
											}
										}
									}

									if(avTemp != null && avTemp != 'null') {
										if (device.type == 'temp' || device.type == 'humi') {
											if (avTemp <= device.threshold_yellow || avTemp >= device.threshold_red) {
												if (room_color != '#FF6D6A') room_color = '#FDE26C';
											}
										} else {
											if (avTemp >= device.threshold_red) {
												room_color = '#FF6D6A';
											} else {
												if (avTemp >= device.threshold_yellow) {
													if (room_color != '#FF6D6A') room_color = '#FDE26C';
												}
											}
										}
									}
								});

								let roomRGBA = 'rgba(' + rgbaCode[room_color].r + ', ' + rgbaCode[room_color].g + ', ' + rgbaCode[room_color].b + ', ' + opacityValue + ')';

								return (
									<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
										<div style={cell_style} onClick={() => this.selectedIAQRoom(room_name)}>
											<div
												className="room_color"
												ref={(divElement) => { this.divElement = divElement }}
												style={{
													display: 'block',
													margin: '10px 5px',
													padding: '10px',
													//border: '1px solid black',
													borderRadius: '10px',
													//backgroundColor: room_color,
													backgroundColor: roomRGBA,
													overflow: 'hidden',
													textOverflow: 'ellipsis'
												}}
											>
												<span style={{ marginLeft: '5px', fontSize: '110%', color: 'black', fontWeight: 'bold', opacity: '1.0', whiteSpace: 'nowrap' }}>  {room_name} </span>
											</div>

											{this.state.iaqMonitoringSettings[room_name].map((device, i) => {
												let deviceName = window.app.state.point_list[device.id].name;
												let unit = window.app.state.point_list[device.id].unit;

												if(isEmpty(unit)) {
													if(window.app.state.point_list[device.id].type == 'Ac') unit = 'DEG';
												}

												let typeTemp = this.props.receiver.getString(device.type);
												//device.type = ['ac', 'co2', 'pm25', 'tvoc', 'co', 'temp', 'humi' ];
												let avTemp = window.app.state.point_list[device.id].av;

												if(isEmpty(avTemp)) {
													if(window.app.state.point_list[device.id].type == 'Ac') {
														if(window.app.state.point_list[device.id].hasOwnProperty('temp')) {
															avTemp = window.app.state.point_list[device.id].temp;
														}
													}
												}

												let iaq_color = '#8BD5A7';
												//#cc3300, #ff9966, #ffcc00, #99cc33, #339900
												//red, 	   beige.	yellow,	 light green, green

												if (device.type == 'temp' || device.type == 'humi') {
													if (avTemp <= device.threshold_yellow || avTemp >= device.threshold_red) {
														iaq_color = '#FDE26C';
													}
												} else {
													if (avTemp >= device.threshold_red) {
														iaq_color = '#FF6D6A';
													} else {
														if (avTemp >= device.threshold_yellow) {
															iaq_color = '#FDE26C';
														}
													}
												}

												if(avTemp == null || avTemp == 'null') {
													avTemp = <span>&nbsp;</span>;
													iaq_color = '#8BD5A7';
												} else {
													avTemp = avTemp + this.props.receiver.getString(unit);
												}

												let iaqRGBA = 'rgba(' + rgbaCode[iaq_color].r + ', ' + rgbaCode[iaq_color].g + ', ' + rgbaCode[iaq_color].b + ', ' + opacityValue + ')';

												return (
													<div style={{ width: '45%', display: 'inline-block', marginLeft: '10px', marginBottom: '10px' }}>
														{/*<div> ID: {device.id} </div>*/}
														{/*<div> Name: {window.app.state.point_list[device.id].name} </div>*/}
														<div className="value" style={{ display: 'flex' }} ref={(divElement) => { this.divElement = divElement }}>
															<div style={{
																display: 'inline-block',
																width: this.state.height,
																height: this.state.height,
																//border: '1px solid black',
																borderRadius: '50%',
																//backgroundColor: iaq_color,
																backgroundColor: iaqRGBA
															}}>
																<img src={iconList[device.type]} style={{ width: this.state.height - 7, paddingTop: 3, paddingLeft: 3 }} />
															</div>
															<div style={{ display: 'inline-block', marginLeft: '5px' }}>
																<span style={{
																	display: 'block',
																	width: cell_width / 3,
																	fontSize: '80%',
																	color: '#707070',
																	whiteSpace: 'nowrap',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis'
																}}>
																	{deviceName}
																</span>
																<span style={{
																	display: 'block',
																	width: cell_width / 3,
																	fontSize: '80%',
																	fontWeight: '500',
																	whiteSpace: 'nowrap',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis'
																}}>
																	{avTemp}
																	{/* { isEmpty(avTemp) ? <span> &nbsp; </span> : avTemp + this.props.receiver.getString(unit) } */}
																</span>
															</div>
														</div>
													</div>
												)
											})}
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}